import { format } from "date-fns";
import React from "react";
import ScrollToTop from "react-scroll-to-top";

const style = {
  'padding-left':'6px',
}
const Footer = () => {
    const det = new Date()
    const date =  format(det, 'PP');
    const splite = date.split(',')[1]
  return (
    <div className="text-center h-36 border-blue-400 border-t-2">
      <ScrollToTop style={style} smooth />
      <div className="mt-12 text-2xl">CopyRight {splite} 💚 © Develop by  Rohit mondal</div>
    </div>
  );
};

export default Footer;
